// The calls API buckets `day` on UTC midnight, but every other day helper in
// this app is local-time (todayLocalISO in useTranscripts, formatLocalDate in
// Calendar). Mixing them is silent: a restaurant in GMT+5 closing at 1am asks
// for the wrong bucket and its late calls simply do not appear.

function toUtcISODate(date: Date): string {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Today's date in UTC as YYYY-MM-DD — what the API means by "today". */
export function todayUtcISO(): string {
  return toUtcISODate(new Date())
}

/**
 * The UTC day a timestamp falls in, as YYYY-MM-DD. Returns null for anything
 * unparseable rather than an Invalid Date string, so a bad row cannot poison a
 * filter comparison.
 */
export function utcDayOf(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (!Number.isFinite(date.getTime())) return null
  return toUtcISODate(date)
}
